import { createFileRoute } from '@tanstack/react-router';
import { Spinner } from '@repo/components';

export const Route = createFileRoute('/personal_/events/$eventId/')({
	component: EventDetailIndex,
});

function EventDetailIndex() {
	return (
		<div className="flex items-center justify-center p-8">
			<Spinner />
		</div>
	);
}
